// extracted by mini-css-extract-plugin
module.exports = {"list":"_82e3db2ea0--list--eH6WL","item":"_82e3db2ea0--item--Qo9lp","icon":"_82e3db2ea0--icon--geEou"};